class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.closeTimer = null;
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 50).bind(this));
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=header`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const results = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-results');
          if (!results) {
            this.close();
            return;
          }

          const resultsMarkup = results.innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          console.error(error);
        });
    }
  
    open() {
      clearTimeout(this.closeTimer);
      this.predictiveSearchResults.style.display = 'block';
      window.requestAnimationFrame(() => {
        this.predictiveSearchResults.classList.add('is-visible');
      });
      this.input.setAttribute('aria-expanded', 'true');
    }
  
    close() {
      this.predictiveSearchResults.classList.remove('is-visible');
      this.input.setAttribute('aria-expanded', 'false');
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        if (!this.predictiveSearchResults.classList.contains('is-visible')) {
          this.predictiveSearchResults.style.display = 'none';
        }
      }, 180);
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
  
